import type { RequestFn } from 'api/useApiRequest';

export const fetchSharedDocumentV2 = (request: RequestFn, { uuid, signal }: { uuid: string; signal?: AbortSignal }) =>
  request({
    method: 'get',
    pathname: `/api/share/document-v2/${encodeURIComponent(uuid)}`,
    authenticated: false,
    signal,
  });
